// Disabling sort rules for this file because it makes more sense to go in order
// of size, rather than alphabetical.
/* eslint-disable sort-keys */

export const MEDIA_TYPES = ["mobile", "tablet", "desktop"] as const;
export type MediaType = (typeof MEDIA_TYPES)[number];

const thresholds = {
  tablet: 600,
  progressInHeader: 720,
  desktop: 900,
};

export const media = {
  mobile: `screen and (max-width: ${thresholds.tablet}px)`,
  tablet: `screen and (min-width: ${thresholds.tablet}px) and (max-width: ${thresholds.desktop}px)`,
  desktop: `screen and (min-width: ${thresholds.desktop}px)`,
  hoverable: "(hover: hover) and (pointer: fine)",
  thresholds,
};
